"use client"

import { useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'

import { lastSearchUrl, writeLastSearch } from './lastSearch'

// Zapisuje bieżący listing osobowych jako ostatnie wyszukiwanie (etykieta liczona na serwerze).
// Adres z location (widoczny w przeglądarce, także przy przepisaniu ścieżki), hooki tylko
// wyzwalają zapis po nawigacji klienckiej.
export default function SaveLastSearch ({ label }) {
    const pathname = usePathname()
    const searchParams = useSearchParams()
    const search = searchParams?.toString() || ''

    useEffect(() => {
        if (label) writeLastSearch(label, lastSearchUrl(location.pathname, location.search))
    }, [label, pathname, search])

    return null
}
